// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfISOWeek as fn } from "../startOfISOWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfISOWeek = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfISOWeek;
